import ArrowUpBgSVG from '../../assets/svg/arrow-up-bg.svg';
export default ArrowUpBgSVG;
